export default __webpack_public_path__ + "static/media/bugFixing.cd8b68f5.svg";